import { BASE_URL, FEATURE_SETTINGS_ENDPOINT, SOMS_API_KEY } from "services/CONSTANTS";
import { SEARCH_MAX_CAP_FAILURE, SEARCH_MAX_CAP_REQUEST, SEARCH_MAX_CAP_RESET, SEARCH_MAX_CAP_SUCCESS } from "./action-type";
import { Get } from "services/apiService";

export const searchMaxCapAction = (params) => {
    return (dispatch) => {
        dispatch(searchMaxCapRequest());

        const apiUrl = `${BASE_URL}${FEATURE_SETTINGS_ENDPOINT}?apikey=${SOMS_API_KEY}`;

        Get({ url: apiUrl, params })
            .then((response) => {
                if (response.status === 200) {
                    dispatch(searchMaxCapSuccess(response));
                } else {
                    dispatch(searchMaxCapFailure(response));
                }
            })
            .catch((err) => {
                dispatch(searchMaxCapFailure(err));
            });
    };
};

const searchMaxCapRequest = () => ({
    type: SEARCH_MAX_CAP_REQUEST,
});

const searchMaxCapSuccess = (response) => ({
    type: SEARCH_MAX_CAP_SUCCESS,
    searchMaxCapResponse: response,
});

const searchMaxCapFailure = (error) => ({
    type: SEARCH_MAX_CAP_FAILURE,
    searchMaxCapResponse: error,
});

export const searchMaxCapReset = () => ({
    type: SEARCH_MAX_CAP_RESET,
});
